export * from "./divider.template";
export * from "./divider";
